module.exports = __webpack_public_path__ + "static/media/rasteplass.c1ec0aca.jpg";